import React from 'react';
import { Container } from './styles';

const PlanCardSelect = ({ children }) => <Container>{children}</Container>;

export default PlanCardSelect;
